<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.fullName || userData.email }}
        </p>
      </div>
      <b-avatar
        size="40"
        :src="$store.state.userData.gravatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!$store.state.userData.gravatar"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <b-dropdown-divider />

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="accountSettings"
      v-if="$store.state.userisloggued"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>{{ $t('My Account') }}</span>
    </b-dropdown-item>
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
      v-if="$store.state.userisloggued"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import store from '@/store/index'
import Apicall from '@/libs/api-call' 

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: store.state.userData,
      avatarText,
    }
  },
  methods: {
    logout() {
      const api = new Apicall()
      api.logout()

      // Reset ability
      //this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'Login' })
    },
    accountSettings() {
      this.$router.push({ name: 'UserAccountSetting' })
    }
  },
}
</script>
